import styled from "styled-components";

export default styled.div`
    width: 80%;
    margin-inline: auto;
    @media (max-width: 768px) {
        width: 95%;
    }
    margin-bottom: 5%;
`;
